import { useSwrData } from './swrWrapper';

export const useFetchAllRoutes = () => {
	const url = `${import.meta.env.VITE_APP_API_URL}/api/getAllRoutes`;
	const data = useSwrData(url, null);
	return data;
};
